<div class="analysis-creation-dialog">
  <p-dialog [(visible)]="showModal" [modal]="true" [dismissableMask]="true" [closable]="true" [draggable]="false"
    styleClass="qubit w-40" (onHide)="closeDialog()" [header]="appName">
    <div *ngIf="appName === 'PollyPhi™ Relative LCMS'; then thenBlock"></div>
  </p-dialog>
</div>

<ng-template #thenBlock>
  <div class="p-1">
    <p> The PollyPhi™ Relative LC-MS workflow has been deprecated, only to give you the all-new El-MAVEN PollyPhi™
      Workflow! The El-MAVEN PollyPhi™ workflow allows you to perform <br> </p>
    <ul>
      <li *ngFor="let text of phiDeprecatedText">
        <p>{{text}}</p>
      </li>
    </ul>
    <br>
    <p> Watch <a [href]="pollyphiWebinarUrl" target="_blank">this</a> webinar to
      understand this workflow with Stable Isotope Resolved Metabolomics, SIRM
      data.
      <br><br>
      In case of any concerns or suggestions, please drop us an email at
      <a href="mailto:{{productEmail}}" target="_blank">{{ 'product@elucidata.io' }}</a>
    </p>
  </div>
</ng-template>
